/* global axios */
import ApiClient from './ApiClient';

class MessageTemplatesAPI extends ApiClient {
  constructor() {
    super('message_templates', { accountScoped: true });
  }

  get({ searchKey } = {}) {
    const url = searchKey ? `${this.url}?search=${searchKey}` : this.url;
    return axios.get(url);
  }
}

export default new MessageTemplatesAPI();
